import { getYear } from 'date-fns';

/**
 * Returns the current year as a number using date-fns.
 *
 * e.g., 2025
 */
export const currentYear = (): number => getYear(new Date());
